var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":"","hide-header":"","visible":"","no-close-on-backdrop":"","centered":"","size":"sm","content-class":"loaderModal"},model:{value:(_vm.showLoader),callback:function ($$v) {_vm.showLoader=$$v},expression:"showLoader"}},[_c('div',{staticClass:"lds-component"},[_c('div',{staticClass:"lds-dual-ring"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }